import { render } from "./Landing.vue?vue&type=template&id=298638ce"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\__MRYNK\\_2022\\_TESTS\\poc-microphone\\poc-record\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__